var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseOp = function SvgPauseOp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 54 54"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "currentColor",
    rx: 27
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pauseOP_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.258 36.281c-1.184 0-1.77-.597-1.77-1.77V17.556c0-1.16.598-1.758 1.77-1.758h2.8c1.16 0 1.758.574 1.758 1.758v16.957c0 1.172-.597 1.77-1.757 1.77zm9.129 0c-1.184 0-1.758-.597-1.758-1.77V17.556c0-1.16.598-1.758 1.758-1.758h2.8c1.172 0 1.77.574 1.77 1.758v16.957c0 1.172-.598 1.77-1.77 1.77z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pauseOP_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.5 13.5h27v27h-27z"
  })))));
};
export default SvgPauseOp;